import Repository from "./RepositoryFactoryMain";
const GET_RM = "getRm";
const GETRMLIST = "getRmList";
const ASSIGN_CHAT = "assignChat";
const RM_CONTACT = "usercontact";
const GET_ASSIGN_RM = "getassignchat";
const GET_ASSIGNRD = "Getassigned";
const checkChatStatus = "checkChatStatus";
const updateChatStatus = "updateChatStatus";
const assignStatus = "assignStatus";
const UPDATE_EXP_CHAT = "updatechatexp";
const GetAllassignchat = "GetAllassignchat";
const AEVRAGECLOSURE = "AverageClosure";
const statusFilter = "statusFilter";

export default {
  GetRM(payload) {
    return Repository.post(transformRoute(GET_RM), payload);
  },
  getRmList(payload) {
    return Repository.post(transformRoute(GETRMLIST), payload);
  },
  AssignChat(payload) {
    return Repository.post(transformRoute(ASSIGN_CHAT), payload);
  },
  RMContact(payload) {
    return Repository.post(transformRoute(RM_CONTACT), payload);
  },
  GetAssignRmName(payload) {
    return Repository.post(transformRoute(GET_ASSIGN_RM), payload);
  },
  GEtAssigned(payload) {
    return Repository.post(transformRoute(GET_ASSIGNRD), payload);
  },
  checkChatStatus(payload) {
    return Repository.post(transformRoute(checkChatStatus), payload);
  },
  updateChatStatus(payload) {
    return Repository.post(transformRoute(updateChatStatus), payload);
  },
  assignStatus(payload) {
    return Repository.post(transformRoute(assignStatus), payload);
  },
  UpdateChatExp(payload) {
    return Repository.post(transformRoute(UPDATE_EXP_CHAT), payload);
  },
  GetAllassignchat(payload) {
    return Repository.post(transformRoute(GetAllassignchat), payload);
  },
  AverageClosure(payload) {
    return Repository.post(transformRoute(AEVRAGECLOSURE), payload);
  },
  statusFilter(payload) {
    return Repository.post(transformRoute(statusFilter), payload);
  },
};

const transformRoute = (route) => {
  return `/agent/${route}`;
};
